import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Spacer, PageDS, ToastContainerDS, TabMenu } from "@qivia/ui";
import { useNavigate, useParams } from "react-router-dom";
import "../../i18n/i18n";
import { VehiclesOfACompanyTab } from "./vehiclesOfACompany";
import { CheckVehiclesEligibilityTab } from "./checkVehiclesEligibility";
import { AddToProviderTab } from "./addToProvider";
import { useAppSelector } from "../../redux/hooks";
import { selectAdminUser } from "../homeSlice";

export const Telemetry = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const adminUser = useAppSelector(selectAdminUser);
  const params = useParams();
  const [selectedTab, setSelectedTab] = useState<string>(
    params.tab ?? "vehiclesOfACompany",
  );

  useEffect(() => {
    if (selectedTab) {
      navigate(
        `/home/telemetry/${selectedTab}${
          params.id !== undefined ? `/${params.id}` : ""
        }`,
      );
    }
  }, [navigate, params.id, selectedTab]);

  if (adminUser?.email === "exterieur1@qivia.fr") {
    navigate("/home");
  }

  const tabs = [
    {
      name: "vehiclesOfACompany",
      title: t("telemetry.tab.vehiclesOfACompany"),
    },
    {
      name: "checkVehiclesEligibility",
      title: t("telemetry.tab.checkVehiclesEligibility"),
    },
    {
      name: "addToProvider",
      title: t("telemetry.tab.addToProvider"),
    },
  ];

  return (
    <PageDS
      title={t(`telemetry.${params.tab}`)}
      toaster={<ToastContainerDS />}
      topElement={
        <>
          <Spacer y={1} />
          <TabMenu
            tabs={tabs}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
        </>
      }
    >
      <VehiclesOfACompanyTab />
      <CheckVehiclesEligibilityTab />
      <AddToProviderTab />
    </PageDS>
  );
};
